import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {
  const { pathname } = useLocation();

  return (
    <div className="navbar1_component">
      <div className="navbar1_container">
        <Link to="/" className="navbar1_logo-link">
          <img
            src="https://cdn.prod.website-files.com/67e26aef79a7047719ea9db8/67e28ceff1544e195a3a2269_astena.svg"
            alt="Astena Logo"
            className="navbar1_logo"
          />
        </Link>
        <nav className="navbar1_menu">
          <Link
            to="/"
            className={`navbar1_link ${pathname === '/' ? 'active' : ''}`}
          >
            Showcase
          </Link>
          <Link
            to="/about"
            className={`navbar1_link ${pathname === '/about' ? 'active' : ''}`}
          >
            About
          </Link>
        </nav>
      </div>
    </div>
  );
}

export default Navbar;
